// extracted by mini-css-extract-plugin
module.exports = {"CopyLinkWrapper":"CopyLinkWrapper--1eOkG"};